import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefundIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.6286 6.14356V6.14356C19.6786 6.14356 21.3404 7.80537 21.3404 9.85531V16.418C21.3404 18.4814 19.6676 20.1542 17.6042 20.1542H6.39571C4.33228 20.1542 2.65955 18.4814 2.65955 16.418V9.87972C2.65955 7.81629 4.33228 6.14356 6.3957 6.14355L6.64637 6.14355",
			stroke: "white",
			strokeWidth: 1.40106
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12.1676L12 5.18155",
			stroke: "white",
			strokeWidth: 1.19761,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.73982 7.97595L12 4.7158L15.2601 7.97595",
			stroke: "white",
			strokeWidth: 1.19761,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10657 15.2281H9.43079C9.75824 15.2281 10.0289 15.4881 10.1723 15.7663C10.3759 16.1613 10.8579 16.6292 12 16.6292C13.1421 16.6292 13.6241 16.1613 13.8277 15.7663C13.9711 15.4881 14.2417 15.2281 14.5692 15.2281H20.8934",
			stroke: "white",
			strokeWidth: 1.40106
		})
	]
});
export default SvgRefundIcon;
